import { ThemeBus } from "./events-bus.js";
import { EVENTS } from "./event-constants.js";

/** Set localStorage key `debugLoadMore` to "1" to enable [load-more] console logs. */
function debugLog(...args) {
  try {
    if (typeof localStorage !== "undefined" && localStorage.getItem("debugLoadMore") === "1") {
      console.log("[load-more]", ...args);
    }
  } catch (_) {}
}

let productsOnPage = null;
let nextUrl = null;
let button = null;
let loadMoreWrapper = null;
let showProductsCount = null;
let isLoading = false;

/**
 * Count only top-level collection product cells. Avoids double-counting nested
 * nodes (e.g. swatches-item-component also uses data-product-id).
 */
function countGridProductCells(container) {
  if (!container) return 0;
  const productRows = container.querySelectorAll(
    ":scope > .product-card[data-collection-grid-item]",
  );
  if (productRows.length > 0) return productRows.length;
  const fallback = container.querySelectorAll(":scope > [data-product-id]");
  return fallback.length;
}

function updateShownProductsCount() {
  if (!productsOnPage || !showProductsCount) return;
  showProductsCount.textContent = String(countGridProductCells(productsOnPage));
}

function updateLoadMoreVisibility() {
    if (!loadMoreWrapper) return;
    loadMoreWrapper.style.display = nextUrl ? "" : "none";
    if (button) button.disabled = isLoading || !nextUrl;
}

async function handleLoadMoreClick() {
    if (isLoading || !nextUrl || !productsOnPage) return;
    isLoading = true;
    updateLoadMoreVisibility();
    try {
      const response = await fetch(nextUrl, { method: "GET" });
      const nextPage = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(nextPage, "text/html");
      const newProducts = doc.querySelector(".product-grid-container");
      if (!newProducts) return;
      nextUrl = newProducts.dataset.loadMoreContainerNext || "";
      // Keep the live grid in sync so initLoadMore (runs on gridUpdated) does not reset nextUrl
      // to a stale value from the first paint.
      if (nextUrl) {
        productsOnPage.dataset.loadMoreContainerNext = nextUrl;
      } else {
        productsOnPage.removeAttribute("data-load-more-container-next");
      }
      productsOnPage.insertAdjacentHTML("beforeend", newProducts.innerHTML);
      updateShownProductsCount();
      debugLog("appended page; nextUrl now", nextUrl || "(none)");
      // Re-init lazy media etc.
      ThemeBus?.dispatchEvent(new CustomEvent(EVENTS.gridUpdated, { detail: { source: "load-more" } }));
    } finally {
      isLoading = false;
      updateLoadMoreVisibility();
    }
  }
function initLoadMore(event) {
  // Re-query fresh DOM after filters/sort replace markup
  productsOnPage = document.querySelector(".product-grid-container");
  button = document.querySelector("[data-load-more-button]");
  loadMoreWrapper = document.querySelector("load-more-pagination");
  showProductsCount = document.querySelector("[data-shown-products-count]");
  nextUrl = productsOnPage?.dataset.loadMoreContainerNext || "";
  debugLog("initLoadMore", {
    trigger: event?.type ?? "sync",
    detail: event?.detail,
    hasGrid: !!productsOnPage,
    nextUrl: nextUrl || "(none)",
    hasButton: !!button,
    hasWrapper: !!loadMoreWrapper,
    hasCountSpan: !!showProductsCount,
  });
  // Avoid duplicate listeners
  button?.removeEventListener("click", handleLoadMoreClick);
  button?.addEventListener("click", handleLoadMoreClick);
  updateShownProductsCount();
  updateLoadMoreVisibility();
}
// Initial mount
initLoadMore();
// Legacy filters.js dispatches gridUpdated; faceted-navigation-filters.js does NOT (lazy load is handled there).
ThemeBus?.addEventListener(EVENTS.gridUpdated, initLoadMore);
ThemeBus?.addEventListener(EVENTS.filtersApplied, initLoadMore);
ThemeBus?.addEventListener(EVENTS.filtersUpdated, initLoadMore);
document.addEventListener("shopify:section:load", initLoadMore);
